import { normalizeStorefrontFeatures, type StorefrontFeatures } from "../features";

const initial = normalizeStorefrontFeatures({});
let snapshot = initial;
const listeners = new Set<() => void>();
export const getStorefrontPreferences = () => snapshot;
export const getServerStorefrontPreferences = () => initial;
export function subscribeStorefrontPreferences(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
export function publishStorefrontPreferences(value: Partial<StorefrontFeatures>) {
  const next = normalizeStorefrontFeatures(value);
  if (JSON.stringify(next) === JSON.stringify(snapshot)) return;
  snapshot = next;
  for (const listener of listeners) listener();
}
